import { CHAPTERS, FIVE_E } from "@/lib/data";
import { Reveal, SectionHeading } from "@/components/Reveal";

const FiveE = () => (
  <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-testid="five-e-list">
    {FIVE_E.map((e, i) => (
      <li key={e.word} className="flex gap-4 rounded-2xl border border-navy/10 bg-white/70 p-4 transition-colors duration-300 hover:border-gold">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-navy font-grotesk text-lg font-extrabold text-gold">
          {i + 1}
        </span>
        <span>
          <span className="block font-semibold text-navy">{e.word}</span>
          <span className="block text-sm text-slate-600">{e.desc}</span>
        </span>
      </li>
    ))}
  </ul>
);

const Chapter = ({ chapter, flip }) => (
  <article className="grid items-start gap-10 lg:grid-cols-12 lg:gap-16" data-testid={`chapter-${chapter.number}`}>
    <div className={`lg:col-span-5 lg:sticky lg:top-32 ${flip ? "lg:order-2" : ""}`}>
      <Reveal>
        <span className="block font-grotesk text-[6rem] font-extrabold leading-none text-azure/10 lg:text-[8rem]">{chapter.number}</span>
        <h3 className="-mt-6 font-display text-3xl leading-[1.05] text-navy sm:text-4xl lg:-mt-10 lg:text-5xl">
          {chapter.title} <em>{chapter.em}</em>
        </h3>
        <p className="mt-6 text-sm leading-relaxed text-slate-600 md:text-base">{chapter.body}</p>
        {chapter.fiveE ? (
          <FiveE />
        ) : (
          <ul className="mt-8 space-y-3">
            {chapter.bullets.map((b) => (
              <li key={b} className="flex items-start gap-3 text-sm text-navy">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" />
                {b}
              </li>
            ))}
          </ul>
        )}
      </Reveal>
    </div>
    <div className={`lg:col-span-7 ${flip ? "lg:order-1" : ""}`}>
      <Reveal delay={0.15}>
        <figure className="group">
          <div className={`relative aspect-[4/3] overflow-hidden bg-navy ${chapter.frame}`}>
            <img
              src={chapter.image}
              alt={chapter.caption}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
            />
          </div>
          <figcaption className="mt-4 flex items-center gap-3 text-xs text-slate-500">
            <span className="h-px w-8 bg-gold" /> {chapter.caption}
          </figcaption>
        </figure>
      </Reveal>
    </div>
  </article>
);

export const Manifesto = () => (
  <section id="tentang" className="relative bg-sand-50 py-28 lg:py-40" data-testid="about-section">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <SectionHeading
        eyebrow="Tentang Masjid"
        title={
          <>
            Sebuah masjid yang <em>tumbuh</em> bersama pesisir.
          </>
        }
        description="Masjid Raudhatul Jannah—yang kini dikenal sebagai Masjid Pantai Bali—adalah tonggak dakwah Islam di pesisir barat Pulau Dewata. Empat babak perjalanannya, dari 1961 hingga hari ini."
      />
      <div className="mt-24 space-y-28 lg:mt-32 lg:space-y-40">
        {CHAPTERS.map((c, i) => (
          <Chapter key={c.number} chapter={c} flip={i % 2 === 1} />
        ))}
      </div>
    </div>
  </section>
);
